import React from 'react'

import { View, Text, Icon } from '../primitives'

const Container = View.extend`
  display: flex;
  height: 28px;
  align-items: center;
  overflow: hidden;
  cursor: pointer;
`

const Label = Text.extend`
  position: relative;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  &:hover {
    opacity: 0.65;
  }
`

const IconBox = View.extend.attrs({ bg: 'accent3Color' })`
  display: inline-block;
  width: 16px;
  height: 16px;
  padding-top: 1px;
  margin-right: 10px;
  line-height: 0;
  border-radius: 2px;
`

const Check = Icon.extend.attrs({
  icon: 'check'
})`
position: relative;
left: 1px;
top: 0;
`

export default ({ children, value, checked, onChange }) => (
  <Container onClick={() => onChange(value, true)}>
    <IconBox>{checked && <Check size={14} color="primary2Color" />}</IconBox>
    <Label>{children}</Label>
  </Container>
)
